import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Column, GridOption, AngularGridInstance, Formatters, Filters, Editors} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';



@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit, OnDestroy {

    displayed = true;
    selected: number;
    gridOptions: GridOption;
    roles: any[];

    show: boolean;
    rolename: string;
    roledesc: string;
    dataset: any[];
    totalData = 0;
    selectedTitles: any[];
    slideChecked = false;

    private respObject: any;
    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private userAuth: Subscription;
    private adminAuth: Subscription;
    private notifier: NotifierService;
    private clientId: number;
    private baseFlag: any;
    offset: number;
    adminRlCheck: boolean;
    adminRole: string;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    roleSelected: any;
    role: any;

    userName: string;
    showExportBtn: boolean;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
  
  
    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (this.baseFlag) {
                        if (!this.edit) {
                            this.notifier.notify('error', 'You do not have edit permission');
                        } else {
                            if (confirm('Are you sure?')) {
                                // console.log('item---' + JSON.stringify(item));
                                this.editItem(item);
                            }
                        }
                    } else {
                        if (!this.messageService.edit) {
                            this.notifier.notify('error', 'You do not have edit permission');
                        } else {
                            if (confirm('Are you sure?')) {
                                // console.log('item---' + JSON.stringify(item));
                                this.editItem(item);
                            }
                        }
                    }
                    break;
                case 'delete':
                    if (this.baseFlag) {
                        if (!this.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            if (confirm('Are you sure?')) {
                                this.deleteItem(item);
                            }
                        }
                    } else {
                        if (!this.messageService.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            if (confirm('Are you sure?')) {
                                this.deleteItem(item);
                            }
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });

    }

    deleteItem(item) {
        console.log(this.clientId)
        this._rest.deleteUserRoleDB({id: item.id, user_id: this.messageService.getUserId(), client_id: this.clientId}).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.messageService.sendAfterDelete(item.id);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.respObject.errorMessage);
        });
    }

    editItem(item) {
        const data = {
            name: item.name, desc: item.roleDesc, createdBy: this.messageService.getUserId(), superAdmin: item.superAdmin, id: item.id
        };
        this._rest.editRoleMst(data).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.notifier.notify('success', 'Updated Successfully');
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.respObject.errorMessage);
        });
    }

    ngOnInit() {
        this.showExportBtn = true;
        this.adminRlCheck = false;
        this.dataLoaded=false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.paginationType = 'next';
        this.page_no = 0;
        this.totalPage = 0;
        this.displayData = {
            pageName: 'Maintain Role ',
            openModalButton: 'Add Role',
            searchModalButton: 'Search',

            breadcrumb: 'Roles',
            folderName: 'All Role',
            tabName: 'Roles',
            exportBtn: 'Export to excel'

        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Role Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'rolename', name: 'Role Name', field: 'name', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'roledesc', name: 'Role Description', field: 'roleDesc', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'adminRole', name: 'Admin Role', field: 'adminRole', sortable: true, formatter: Formatters.checkmark, filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, minWidth: 40, filterable: true, cssClass: 'highlight', editor: {
                    model: Editors.checkbox
                }
            }

        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
    const createdBy =   this.messageService.getUserId()

    this.searchData.valueChanges.subscribe(
        name => {
            if (name.length > 2) {
                this.isLoading = true;
                this._rest.searchAllRoles(name, createdBy).subscribe((res1) => {
                    this.respObject = res1;
                    this.isLoading = false;
                    if (this.respObject.success) {
                        this.role = this.respObject.details;
                        // console.log("true"+ JSON.stringify(this.role));
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.isLoading = false;
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            } else {
                this.role = [];
            }
        });
    }

    onPageLoad() {
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    exportToExcel() {
        // console.log("okkk" +this.clientId);
        this._rest.getAllRoleData(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataExcel = this.respObject.details;
                // console.log("true"+ JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }
    

    openModal(content) {
        if (this.baseFlag) {
            if (!this.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.rolename = '';
                this.roledesc = '';
                this.adminRlCheck = false;
                this.modalService.open(content, {size: 'sm'}).result.then((result) => {
                }, (reason) => {

                });
            }
        } else {
            if (!this.messageService.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.rolename = '';
                this.roledesc = '';
                this.modalService.open(content, {size: 'sm'}).result.then((result) => {
                }, (reason) => {

                });
            }
        }
    }

    searchModal() {
        if (this.baseFlag) {
            if (!this.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
        
                this.roleSelected = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
        
                });
                    }
        } else {
            if (!this.messageService.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.roleSelected = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
        
                });
                    }
        }
    }

    search() {
      const data1 = [];
      for (let i = 0; i < this.role.length; i++) {
          if (this.role[i].name === this.roleSelected) {
            data1.push(this.role[i]);
          }
      }
      this.page_no = 1;
      this.messageService.setTotalData(data1.length);
      this.messageService.setGridData(data1);
      this.searchModalReference.close();


    }
    save() {
        this.adminRole = String(this.adminRlCheck);
        const data = {
            client_id: this.clientId,
            name: this.rolename,
            desc: this.roledesc,
            superadmin: this.adminRole,
            createdBy: this.messageService.getUserId()
        };
        // console.log('AAAAAAAAAA===' + JSON.stringify(data) + "===" + this.adminRlCheck);
        if (!this.messageService.isBlankField(data)) {
            this._rest.addRole(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    const id = this.respObject.roleId;
                    this.messageService.setRow({name: this.rolename, roleDesc: this.roledesc, id: id, adminRole: this.adminRlCheck});
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.rolename = '';
                    this.roledesc = '';
                    this.slideChecked = false;
                    this.adminRlCheck = false;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = err;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (this.baseFlag) {
            if (!this.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
            }
        } else {
            if (!this.messageService.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
            }
        }
    }

    getNewTableData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getAllRoles(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            console.log(JSON.stringify(this.respObject));

            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('err', this.messageService.SERVER_ERROR);
        });
    }

    slideChange() {
        this.slideChecked = !this.slideChecked;
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    // getData(paginationObj) {
    //   const offset = paginationObj.offset;
    //   const paginationType = paginationObj.paginationType;
    //   this._rest.getSomeModules(offset, this.pageSize, paginationType).subscribe((res) => {
    //     this.respObject = res;
    //     this.executeResponse(this.respObject, offset, paginationType);
    //   }, (err) => {
    //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //   });
    // }
    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
